import React from "react";

function Privacidadeflappycopter() {
  return (
    <div className="ifo animate-fade-in">
      <h1 className="gamename mb-6">Política de Privacidade – Flappy Copter</h1>
      
      <div className="space-y-6">
        <section className="transform hover:scale-[1.02] transition-all duration-300">
          <h2 className="tgh text-blue-400 mb-3">Última atualização: 19/05/2025</h2>
          <p className="tjh">
            Bem-vindo ao <span className="text-white font-medium">Flappy Copter!</span> Esta Política de Privacidade explica como tratamos suas informações ao utilizar nosso jogo. Respeitamos sua privacidade e não coletamos dados pessoais.
          </p>
        </section>

        <section className="transform hover:scale-[1.02] transition-all duration-300">
          <h2 className="tgh text-blue-400 mb-3">1. Informações Coletadas</h2>
          <p className="tjh">
            O <span className="text-white font-medium">Flappy Copter NÃO coleta </span>
<br/>
            nenhuma informação pessoal identificável, como nome, e-mail, localização ou número de telefone.<br/>
            Podemos coletar<span className="text-white font-medium"> dados não identificáveis</span>, localmente no seu dispositivo, como:
<br/>
<br/>

<ul>
  <li>Pontuação e progresso no jogo</li>
  <li>Configurações e preferências de jogo</li>
</ul>
<br/>
<br/>
Esses dados são armazenados apenas localmente no seu dispositivo, e não são enviados para servidores externos.
          </p>
        </section>

        <section className="transform hover:scale-[1.02] transition-all duration-300">
          <h2 className="tgh text-blue-400 mb-3">2. Armazenamento Local</h2>
          <p className="tjh">
          O Flappy Copter pode salvar dados no seu dispositivo para garantir uma experiência contínua e personalizada, mesmo quando estiver offline.
          </p>
        </section>

        <section className="transform hover:scale-[1.02] transition-all duration-300">
          <h2 className="tgh text-blue-400 mb-3">3. Segurança</h2>
          <p className="tjh">
            Embora não coletemos dados pessoais, adotamos práticas básicas para garantir que os dados armazenados localmente no seu dispositivo estejam protegidos contra perdas ou acesso indevido.
          </p>
        </section>

        <section className="transform hover:scale-[1.02] transition-all duration-300">
          <h2 className="tgh text-blue-400 mb-3">4. Privacidade Infantil</h2>
          <p className="tjh">
            O Flappy Copter pode ser jogado por todas as idades. Não coletamos nem solicitamos dados de menores de 13 anos, nem de qualquer outro usuário.
          </p>
        </section>

         <section className="transform hover:scale-[1.02] transition-all duration-300">
          <h2 className="tgh text-blue-400 mb-3">5. Alterações nesta Política</h2>
          <p className="tjh">
           Podemos atualizar esta Política de tempos em tempos. Qualquer mudança será informada através de uma nova versão publicada junto ao jogo.
          </p>
        </section>

        <div className="mt-8 p-4 bg-blue-600/20 rounded-lg backdrop-blur-sm">
          <p className="tjh text-center">
            Ao usar o Flappy Copter, você concorda com nossa Política de Privacidade.
            Se tiver dúvidas, entre em contato conosco através do email
            <a href="mailto:moregames.ao@gmail.com" className="text-blue-400 hover:text-blue-300 ml-1 transition-colors duration-300">
              moregames.ao@gmail.com
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Privacidadeflappycopter;
  